/**
 * Первая загрузка (§11.1): хром уже настоящий, тело таблицы — статичный
 * скелетон 12 строк × 28 px. Без спиннеров и переливов: на 2 vCPU статика
 * честнее мерцания, и при prefers-reduced-motion ничего не меняется.
 */
import { texts } from '../texts.js'
import './screens.css'

/** Ширины колонок набора по умолчанию канала «Розница» (§4.2). */
const COLUMNS = [36, 212, 48, 28, 40, 200, 140, 110, 72, 88, 36] as const
const ROWS = 12

export function LoadingScreen() {
  return (
    <div className="skel" role="status" aria-busy="true" aria-label={texts.loading.tableLabel}>
      <div className="skel__head">
        {COLUMNS.map((width, index) => (
          <span className="skel__cell" style={{ width }} key={index} />
        ))}
      </div>
      {Array.from({ length: ROWS }, (_, row) => (
        <div className="skel__row" key={row}>
          {COLUMNS.map((width, index) => (
            <span className="skel__cell" style={{ width }} key={index}>
              {/* Прямоугольник 60 % ширины колонки (§2.3 Skeleton). */}
              <span className="skel__bar" />
            </span>
          ))}
        </div>
      ))}
    </div>
  )
}
